<template>
  <div>
    <h2>購物車</h2>
    <p>這裡顯示已加入的商品與結帳流程。</p>
  </div>
</template>
<script>export default { name: 'Cart' }</script>
